import { render, staticRenderFns } from "./newMaterialArticle.vue?vue&type=template&id=5014d4dc&scoped=true&"
import script from "./newMaterialArticle.vue?vue&type=script&lang=js&"
export * from "./newMaterialArticle.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialArticle.vue?vue&type=style&index=0&id=5014d4dc&lang=less&scoped=true&"
import style1 from "./newMaterialArticle.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5014d4dc",
  null
  
)

component.options.__file = "newMaterialArticle.vue"
export default component.exports